import { render, staticRenderFns } from "./PageClubTerminalList.vue?vue&type=template&id=0cb83694&scoped=true&"
import script from "./PageClubTerminalList.vue?vue&type=script&lang=js&"
export * from "./PageClubTerminalList.vue?vue&type=script&lang=js&"
import style0 from "./PageClubTerminalList.vue?vue&type=style&index=0&id=0cb83694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb83694",
  null
  
)

export default component.exports